import { render } from "./Attivita.vue?vue&type=template&id=5d921122&ts=true"
import script from "./Attivita.vue?vue&type=script&lang=ts"
export * from "./Attivita.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__